import { useMemo } from 'react';
import HelperFunctions from 'pages/global/HelperFunctions';
import { filterVariants } from 'pages/documents/misc/_EditArea/EditAreaSidebar';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { Notification } from 'components/Notification';
import { CircleFill } from 'react-bootstrap-icons';

const emptyArray = [];

export function useGetDocumentVariantOptions(baseVariant, availableVariants = [], showBaseVariant = true) {
    const { t } = useTranslation('documents');

    return useMemo(() => {
        const localVariants = [];

        if (!baseVariant) {
            return emptyArray;
        }

        const filtered = HelperFunctions.flatten(
            availableVariants.length > 0
                ? filterVariants(baseVariant.children, availableVariants)
                : baseVariant.children,
        );

        if (showBaseVariant) {
            localVariants.push({
                label: <VariantSelectRow name={t('global:entities.baseVariant')} />,
                value: baseVariant.id,
                variant: {
                    prefix: '',
                    name: t('global:entities.baseVariant'),
                },
            });
        }

        filtered
            .filter((_variant) => _variant.parentId === baseVariant.id || _variant.variantGroup)
            .forEach((_variant) => {
                if (_variant.variantGroup) {
                    localVariants.push({
                        label: <VariantSelectRow name={_variant.name} prefix={_variant.prefix} />,
                        options: filtered
                            .filter(
                                (_childVariant) =>
                                    _childVariant.parentId === _variant.id && _childVariant.variantGroup === false,
                            )
                            .map((_childVariant) => {
                                return {
                                    label: <VariantSelectRow name={_childVariant.name} prefix={_childVariant.prefix} />,
                                    value: _childVariant.id,
                                    variant: {
                                        prefix: _childVariant.prefix ?? '',
                                        name: _childVariant.name,
                                    },
                                };
                            }),
                    });
                } else {
                    localVariants.push({
                        label: <VariantSelectRow name={_variant.name} prefix={_variant.prefix} />,
                        value: _variant.id,
                        variant: {
                            prefix: _variant.prefix ?? '',
                            name: _variant.name,
                        },
                    });
                }
            });

        return localVariants;
    }, [baseVariant, availableVariants, showBaseVariant]);
}

function VariantSelectRow({ name, prefix = null, checkCount = 0, showWarningIndicator = false }) {
    return (
        <div className="d-flex align-items-center justify-content-between">
            <div>
                {!_.isNil(prefix) && <span className="text-muted">{prefix}&nbsp;&nbsp;</span>}
                <span>{name}</span>
            </div>

            {checkCount > 0 && <Notification count={checkCount} />}
            {checkCount === 0 && showWarningIndicator && <CircleFill className="text-danger" size={8} />}
        </div>
    );
}
